import { useRouter } from 'next/navigation';
import { useIntl } from 'react-intl';

import { FocusRingVariants, FontWeights, Text } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';
import { useAnalytics } from '@/hooks/analytics';
import { usePurchaseParamsState } from '@/hooks/store';

import messages from './messages';
import {
	AppSection,
	Body,
	Button,
	ButtonContainer,
	Heading,
	ImageContainer,
	StickyCopy,
	Wrapper,
} from './styles';

const Hero = ({ handleCtaClick, isFullHeight }: { handleCtaClick: () => void; isFullHeight?: boolean }) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();
	const { giftPrice } = usePurchaseParamsState();
	const router = useRouter();

	const handleCta = () => {
		logEvent({
			eventName: 'Gift : CTA : Clicked',
			eventProps: {
				copy: formatMessage(messages.cta),
				type: 'button',
			},
		});

		handleCtaClick();
	};

	const handleSecondaryCta = () => {
		logEvent({
			eventName: 'Gift : CTA : Clicked',
			eventProps: {
				copy: formatMessage(messages.secondaryCta),
				type: 'button',
			},
		});
		return router.push('/redeem');
	};

	const discountPercent =
		giftPrice?.price && giftPrice?.originalPrice
			? 100 - Math.ceil((giftPrice?.price / giftPrice?.originalPrice) * 100)
			: 0;

	return (
		<Wrapper isFullHeight={isFullHeight}>
			<ImageContainer>
				<Image
					priority
					loading="eager"
					fill
					style={{ objectFit: 'cover', objectPosition: 'center bottom' }}
					src="/_n/images/gift-card/section-giftcard.webp"
					alt=""
				/>
			</ImageContainer>
			<AppSection>
				<StickyCopy>
					<Heading>{formatMessage(messages.heading)}</Heading>
					<Body>
						{formatMessage(messages.body1)}
						{giftPrice?.price !== giftPrice?.originalPrice && discountPercent !== 0 && (
							<Text color="blue3">{formatMessage(messages.body2, { discountPercent })}</Text>
						)}
					</Body>
					<ButtonContainer>
						<Button
							fullWidth
							onPress={handleCta}
							maxWidth="218px"
							fontWeight={FontWeights.Demi}
							backgroundColor="accessibleBrandGradient"
							textColor="white"
							focusRingVariant={FocusRingVariants.Dark}
						>
							{formatMessage(messages.cta)}
						</Button>
						<Button
							fullWidth
							onPress={handleSecondaryCta}
							maxWidth="218px"
							fontWeight={FontWeights.Demi}
							backgroundColor="buttonSecondaryBg"
							textColor="buttonBlue"
							borderColor="blackAlpha20"
						>
							{formatMessage(messages.secondaryCta)}
						</Button>
					</ButtonContainer>
				</StickyCopy>
			</AppSection>
		</Wrapper>
	);
};

export default Hero;
